import React from 'react';

export default class CmsElementCommerceProduct extends React.Component {
  render() {
    const {
      intl: { messages },
      setParam,
      navigateBack,
    } = this.props;

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.single_product}</b>
        </div>

        <div class="form-group-attached"></div>
      </>
    );
  }
}
